import { render, staticRenderFns } from "./add-banner.vue?vue&type=template&id=52e54d1e&"
import script from "./add-banner.vue?vue&type=script&lang=js&"
export * from "./add-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports